import { FontWeights } from '@fluentui/theme';

export const LabelStyles = {
  root: {
    fontWeight: FontWeights.regular,
  },
};
